


<template lang="jade">

	div.logo(
		v-if="$route.name !== 'trailer'"
	)
		img(src="/static/img/w4rd-logo.png")


</template>



<script>



	const $cmp = {
		name : 'logo',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.logo
		position absolute
		top 35px
		left 50%
		transform translate(-50%,0%)
		z-index 4

		@media(max-width 1023px)
			top 40px

	.logo img
		height 65px
		width auto

		@media(max-width 1023px)
			height 40px

</style>



// WEBPACK FOOTER //
// src/components/home/logo.vue